import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isRemove === false)?_c(VDialog,{attrs:{"max-width":"600","scrollable":""},model:{value:(_vm.dialogModel),callback:function ($$v) {_vm.dialogModel=$$v},expression:"dialogModel"}},[_c(VCard,[_c('div',{staticClass:"subtitle-2 px-4 pt-4 pb-2"},[_vm._v(_vm._s(_vm.name))]),_c(VCardText,{staticClass:"px-4 pb-4"},[_c('div',{staticClass:"overflow-auto"},[_c('pre',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.content))])])])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }